// @ts-ignore
import Api from "@/repository/api";
import {ResponseDataType} from "@/form/form.types";
import {IUserRepository} from "@/repository/user/UserRepository.types";
import {IUser, UserResponseType, IUsers, UsersResponseType} from "@/entity/user/user.types";
import User, {Users} from "@/entity/user/user";

export class UserRepository implements IUserRepository {
    async fetchAll(data?: FormData): Promise<IUsers>{
        console.log('++++++++++++++++++++1677494977++++++++++++++++++++++++');console.log('data : ' + (typeof data));console.log(data);console.log('--------------------1677494977------------------------');

        const response = await Api.get('/user/get', {
            params: data,
            paramsSerializer: function paramsSerializer(params) {
                let kik = new URLSearchParams(params).toString();

                return new URLSearchParams(params).toString()
            }});

        const responseData = response.data as UsersResponseType;

        return new Users(responseData);
    }
    async fetch(): Promise<IUser> {
        const resp = await Api.post('/user');
        const respData = resp.data as UserResponseType;
        return new User(respData);
    }
    async delete(data: { id: number }): Promise<ResponseDataType> {
        const resp = await Api.post('/user/delete', data);
        return resp.data;
    }
}